import BaseEntity from '../BaseEntity.model';
import { Progress } from './Progress.model';

export default interface INextStep extends BaseEntity {
    Name: string;
    Progress: Progress[];
    CreatedAt: string;
    UpdatedAt: string;
}

export class NextStep implements INextStep {
    Id: string | null;
    Name: string;
    Progress: Progress[];
    CreatedAt: string;
    UpdatedAt: string;

    IsSelected: boolean;
    IsOpenProgress: boolean;
    NewProgressNote: string;

    constructor() {
        this.Id = null;
        this.Name = '';
        this.CreatedAt = '';
        this.UpdatedAt = '';

        this.IsSelected = false;
        this.IsOpenProgress = false;
        this.NewProgressNote = '';
    }
}
